import React, { useState } from 'react'

function Admin() {
	const [bookName, setBookName] = useState('')
	const domain = 'https://wohelo-yearbooks.web.app/yearbook/'
	const [generatedURL, setGeneratedURL] = useState(null)

	const generateURL = () => {
		setGeneratedURL(domain + bookName)
	}

	return (
		<div className='App'>
			<div className='form-1'>
				<h1>Generate URL</h1>
				<input
					className='book-input'
					type='text'
					value={bookName}
					placeholder='Enter book name'
					onChange={(e) => setBookName(e.target.value)}
				/>

				<input
					className='generate'
					type='button'
					value='Generate'
					onClick={() => generateURL()}
				/>
			</div>

			{generatedURL && (
				<div className='form-2'>
					<p>Copy the URL below</p>
					<input
						className='url-output'
						value={generatedURL}
						onClick={() => {}}
					/>
				</div>
			)}
		</div>
	)
}

export default Admin
